import { FileText, ImageIcon, Download } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const fileUrl = (f) => `${BACKEND}/api/files/${f.storage_path}`;

const isImage = (f) => (f?.content_type || "").startsWith("image/");

/** Compact strip of file thumbnails + downloadable filenames.
 * `files` = array of FileRef. Empty list renders nothing. */
export const FileGallery = ({ files = [], label = "Files", testid = "file-gallery", size = 96 }) => {
    if (!files?.length) return null;
    return (
        <div className="space-y-2" data-testid={testid}>
            <div className="text-[10px] uppercase tracking-widest text-stone-500">{label} ({files.length})</div>
            <div className="flex flex-wrap gap-2">
                {files.map((f, i) => (
                    <a
                        key={f.id || i}
                        href={fileUrl(f)}
                        target="_blank"
                        rel="noreferrer"
                        className="group block border border-stone-200 bg-white hover:border-emerald-500/60 transition-colors"
                        style={{ width: size, height: size }}
                        title={f.original_filename}
                        data-testid={`${testid}-item-${i}`}
                    >
                        {isImage(f) ? (
                            <img src={fileUrl(f)} alt={f.original_filename} className="w-full h-full object-cover" />
                        ) : (
                            <div className="w-full h-full flex flex-col items-center justify-center gap-1 text-stone-500 group-hover:text-emerald-700 p-2">
                                <FileText className="h-6 w-6" strokeWidth={1.2} />
                                <span className="text-[9px] text-center truncate w-full">{f.original_filename}</span>
                            </div>
                        )}
                    </a>
                ))}
            </div>
        </div>
    );
};

/** Single-file inline download link (used for invoices) */
export const FileLink = ({ file, label, testid }) => {
    if (!file) return null;
    return (
        <a
            href={fileUrl(file)}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 text-sm text-emerald-700 hover:text-emerald-800 underline decoration-emerald-500/40 hover:decoration-emerald-600"
            data-testid={testid}
        >
            {isImage(file) ? <ImageIcon className="h-3.5 w-3.5" /> : <FileText className="h-3.5 w-3.5" />}
            {label || file.original_filename}
            <Download className="h-3 w-3" />
        </a>
    );
};

export default FileGallery;
